<template>
  <el-dialog
    title="编辑段落"
    :visible.sync="dialogFormVisible"
    :close-on-click-modal="false"
    @close="dialogClose"
    custom-class="custom_dialog"
  >
    <div
      style="overflow-y: auto; padding: 0px 30px 0px 10px"
      :style="formBodyStyle"
    >
      <el-form
        :model="elementItem"
        :rules="questionFormRules"
        ref="elementItem"
        label-width="140px"
        class="demo-ruleForm"
        size="mini"
        :label-position="is_xs ? 'top' : 'right'"
      >
        <el-form-item label="章节：" prop="Title">
          <VueUeditorWrap
            ref="contentUeditor"
            v-model="elementItem.Title"
            :config="ueditorConfig"
          ></VueUeditorWrap>
        </el-form-item>
        <el-form-item label="阅卷是否合并打分：" prop="IsManualMerge">
          <el-switch v-model="elementItem.IsManualMerge"> </el-switch>
        </el-form-item>
        <el-form-item label="是否只在阅卷显示：" prop="IsOnlyManualShow">
          <el-switch v-model="elementItem.IsOnlyManualShow"> </el-switch>
        </el-form-item>
      </el-form>
    </div>
    <div
      slot="footer"
      class="dialog-footer"
      style="overflow-y: auto; padding: 0px 30px 0px 10px"
    >
      <el-button @click="dialogFormVisible = false">取 消</el-button>
      <el-button type="primary" @click="editElementTitle()"> 保 存 </el-button>
    </div>
  </el-dialog>
</template>

<script>
import questionnaireApi from '../../api/wj/questionnaire'
import ueditorConfig from '../../assets/js/ueditorConfig_simple'
import VueUeditorWrap from 'vue-ueditor-wrap'
export default {
  name: 'EditElementTitle',
  components: {
    VueUeditorWrap
  },
  data () {
    return {
      dialogFormVisible: false,
      formBodyStyle: { maxHeight: (window.innerHeight - 250) + 'px' },
      ueditorConfig: ueditorConfig,
      elementItem: {},
      questionFormRules: {
        Title: [
          { required: true, message: '请输入章节', trigger: 'blur' }]
      }
    }
  },
  props: {
    fatherSubmitDialog: {
      type: Function,
      default: null
    }
  },
  methods: {
    openEditElementTitle: function (item) {
      this.dialogFormVisible = true
      this.elementItem = item
    },
    editElementTitle: function () {
      const _this = this
      _this.$refs.elementItem.validate((valid) => {
        if (valid) {
          const openLoading = this.openLoading()
          questionnaireApi.editQuestionnaireElement(_this.elementItem).then(data => {
            _this.$message({
              showClose: true,
              type: 'success',
              message: '保存成功!',
              customClass: 'custom_message'
            })
            openLoading.close()
            _this.fatherSubmitDialog(_this.elementItem)
            _this.dialogFormVisible = false
          }).catch(err => {
            openLoading.close()
            return err
          })
        } else {
          return false
        }
      })
    },
    dialogClose: function (done) {
    }
  },
  created () {

  }
}
</script>
<style lang="less">
</style>
